import * as React from 'react';
import { Code, List } from 'react-content-loader';

export default function Placeholder() {
  return (
    <div className='nv-open-search'>
      <div className='row'>
        <div className='col-lg-3 col-md-12 col-sm-12 col--filters'>
          {[...Array(5).keys()].map((e,k) => {
            return <Code key={k} speed={2} width={300} height={150} viewBox='0 0 300 150'/>
          })}
        </div>
        <div className='col-lg-9 col-md-12 col-sm-12'>
          <List />
        </div>
      </div>
    </div>
  );
}
